import { Alert, AlertTitle } from "@mui/material";
import { useEffect, useRef } from "react";

/**
 * Every reason a dialog refused to commit, focused on mount so it scrolls into
 * view and is announced. Key it by a refusal count to re-focus on each refusal.
 */
export function BlockingIssues({ title, messages }: { title: string; messages: string[] }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return (
    <Alert severity="error" ref={ref} tabIndex={-1}>
      <AlertTitle>{title}</AlertTitle>
      <ul style={{ margin: 0, paddingInlineStart: "1.25rem" }}>
        {messages.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </Alert>
  );
}
